import { useRouter } from "next/router";
import styled from "styled-components";
import dayjs from "dayjs";
import Header from "@/components/main/Header";
import Footer from "@/components/main/Footer";
import type { TBlog } from "@/pages/api/admin/blog";
import { useEffect, useState } from "react";

import MarkdownPreview from "@uiw/react-markdown-preview";
import "@uiw/react-markdown-preview/markdown.css";

const Content = styled.div`
  margin: 0 auto;
  padding: 0 20px;
  max-width: 1000px;
`;

const HeaderWrap = styled.div`
  min-height: 570px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
`;
const HeaderWrapDimd = styled.div`
  width: 100%;
  height: 100%;
  background-color: rgb(45, 45, 45, 0.4);
`;
const HeaderContent = styled(Content)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 570px;
`;
const Title = styled.p`
  margin: 20px 0 25px 0;
  font-family: "Lato Bold";
  font-size: 40px;
  line-height: 40px;
  font-weight: 700;
  color: #fff;
  text-align: center;
`;
const Descs = styled.p`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const DescSeparator = styled.div`
  width: 1px;
  height: 15px;
  background-color: rgba(255, 255, 255, 0.4);
`;
const Desc = styled.p`
  margin: 0 20px;
  font-family: "Hind";
  font-weight: 300;
  font-size: 16px;
  color: #fff;
`;

const BodyWrap = styled.div`
  padding: 80px 0 200px 0;
  background-color: #fff;
`;
const BodyContent = styled(Content)``;

export default function Page() {
  const router = useRouter();
  const [blog, setBlog] = useState<TBlog | null>(null);

  useEffect(() => {
    async function init() {
      const newBlog = await fetchBlog(Number(router.query.id));
      if (!newBlog) return;

      setBlog(newBlog);
    }
    init();
  }, [router.query.id]);

  if (!Boolean(blog)) return <>Item not found.</>;

  return (
    <>
      <Header />
      <HeaderWrap style={{ backgroundImage: `url(${blog?.bg})` }}>
        <HeaderWrapDimd>
          <HeaderContent>
            <Title>{blog?.title}</Title>
            <Descs>
              {/* <Desc>{item.author}</Desc> */}
              <DescSeparator />
              <Desc>{dayjs(blog?.created_date).format("MMMM D, YYYY")}</Desc>
            </Descs>
          </HeaderContent>
        </HeaderWrapDimd>
      </HeaderWrap>
      <BodyWrap>
        <BodyContent data-color-mode="light">
          <MarkdownPreview source={blog?.content} style={{ whiteSpace: "pre-wrap" }} />
        </BodyContent>
      </BodyWrap>
      <Footer />
    </>
  );
}

async function fetchBlog(id: number): Promise<TBlog | null> {
  const res = await fetch("/api/blog", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ id }),
  });

  const result = await res.json();
  return result.result;
}
